<template>
  <!-- Le journal des stores (REDMINE-13522) : preuves d'achat de l'app,
       notifications d'Apple et de Google, relectures. Les refus y portent leur
       motif : c'est la premiere chose a regarder quand un achat « ne passe pas ». -->
  <div class="index py-5">
    <div class="d-flex align-center">
      <span class="d-flex flex-row page-title">{{ $t('intranet.title.menu.billing.events') }}</span>
      <v-spacer></v-spacer>
      <v-switch v-model="onlyErrors" :label="$t('intranet.billing.onlyErrors')" hide-details></v-switch>
    </div>

    <div class="searchable-list-container">
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :options.sync="options"
        :server-items-length="total"
        :footer-props="{ 'items-per-page-options': [25, 50, 100] }"
      >
        <template v-slot:item.received-at="{ item }">{{ date(item['received-at']) }}</template>
        <template v-slot:item.user-id="{ item }">
          <router-link v-if="item['user-id']" :to="`/authenticated/users/read/${item['user-id']}`">{{ item['user-id'].slice(0, 8) }}</router-link>
          <span v-else>—</span>
        </template>
        <template v-slot:item.error="{ item }">
          <span :class="item.error ? 'error--text' : ''">{{ item.error || '—' }}</span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { errorHandler } from 'aveine-toolbox'
import { search, formatDate } from '@/components/billing/billing-api'

export default {
  name: 'BillingEvents',
  data () {
    return { items: [], total: 0, loading: false, onlyErrors: false, options: { page: 1, itemsPerPage: 25 } }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('intranet.billing.receivedAt'), value: 'received-at', sortable: false },
        { text: this.$t('intranet.billing.store'), value: 'store', sortable: false },
        { text: this.$t('intranet.billing.source'), value: 'source', sortable: false },
        { text: this.$t('intranet.billing.type'), value: 'type', sortable: false },
        { text: this.$t('intranet.billing.user'), value: 'user-id', sortable: false },
        { text: this.$t('intranet.billing.error'), value: 'error', sortable: false }
      ]
    }
  },
  watch: {
    options: { handler () { this.load() }, deep: true },
    onlyErrors () { this.options = { ...this.options, page: 1 } }
  },
  methods: {
    date (value) { return formatDate(value, this.$i18n.locale) },
    async load () {
      this.loading = true
      try {
        const params = { sort: '-received-at', 'page[number]': this.options.page, 'page[size]': this.options.itemsPerPage }
        if (this.onlyErrors) params['filter[error][NE]'] = 'null'
        const page = await search(this.$auth, '/billing-store-events', params)
        this.items = page.items
        this.total = page.total
      } catch (errors) {
        errorHandler(errors, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
